export default __webpack_public_path__ + "static/media/Icon-Childcare.df8a2d11.svg";